import { ActionIcon, Group } from '@mantine/core';
import { MdOutlineRemoveRedEye, MdEdit, MdDelete } from 'react-icons/md';

interface Props {
  row: object;
  editAction?: (...args: any[]) => void;
  viewAction?: (...args: any[]) => void;
  deleteAction?: (...args: any[]) => void;
}

const TableActions = (props: Props) => {
  return (
    <Group>
      {props.viewAction && (
        <ActionIcon variant="transparent">
          <MdOutlineRemoveRedEye onClick={props.viewAction} size={20} color="black" />
        </ActionIcon>
      )}
      {props.editAction && (
        <ActionIcon variant="transparent">
          <MdEdit onClick={props.editAction} size={20} color="black" />
        </ActionIcon>
      )}
      {props.deleteAction && (
        <ActionIcon variant="transparent">
          <MdDelete onClick={props.deleteAction} size={20} color="black" />
        </ActionIcon>
      )}
    </Group>
  );
};

export default TableActions;
